import update from 'immutability-helper';
import {
  REQUEST_INIT,
  REQUEST_LOADING,
  REQUEST_FAIL,
  REQUEST_SUCCESS,
  INIT_COLLECTIONS,
  GET_COLLECTIONS_LOADING,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAIL,
  CLEAN_COPY_COLLECTIONS_BOX,
  SHOW_COPY_COLLECTIONS_BOX,
  SET_COLLECTIONS_LIKE,
  COPY_COLLECTIONS_LOADING,
  COPY_COLLECTIONS_SUCCESS,
  COPY_COLLECTIONS_FAIL,
  SHOW_COLLECTIONS_SHARE,
  CLEAN_COLLECTIONS_SHARE,
} from '../actions/action_types';

export default (
  state = {
    isShowCopyBox: false,
    isShowShareMenu: false,
    copyBox: {
      requestStatus: REQUEST_INIT,
    },
    id: '',
    owner: {},
    isLike: false,
    loading: false,
    name,
    likeCount: 0,
    commentCount: 0,
    copyCount: 0,
    readCount: 0,
    pageview: 0,
    cover: {},
    publishedAt: 0,
    areas: [],
    pois: [],
  },
  action,
) => {
  switch (action.type) {
    case INIT_COLLECTIONS:
      return {
        isShowCopyBox: false,
        isShowShareMenu: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
        id: '',
        owner: {},
        isLike: false,
        loading: false,
        name,
        likeCount: 0,
        commentCount: 0,
        copyCount: 0,
        readCount: 0,
        pageview: 0,
        cover: {},
        publishedAt: 0,
        areas: [],
        pois: [],
      };
    case GET_COLLECTIONS_LOADING:
      return { ...state, loading: true };
    case GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case GET_COLLECTIONS_FAIL:
      return {
        isShowCopyBox: false,
        isShowShareMenu: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
        id: '',
        owner: {},
        isLike: false,
        loading: false,
        name,
        likeCount: 0,
        commentCount: 0,
        copyCount: 0,
        readCount: 0,
        pageview: 0,
        cover: {},
        publishedAt: 0,
        areas: [],
        pois: [],
      };
    case CLEAN_COPY_COLLECTIONS_BOX:
      return {
        ...state,
        isShowCopyBox: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
      };
    case SHOW_COPY_COLLECTIONS_BOX:
      return {
        ...state,
        isShowCopyBox: true,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
      };
    case SET_COLLECTIONS_LIKE:
      return {
        ...state,
        likeCount: action.payload.likeCount,
        isLike: action.payload.isLike,
      };
    case COPY_COLLECTIONS_LOADING:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_LOADING,
        },
      };
    case COPY_COLLECTIONS_SUCCESS:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_SUCCESS,
        },
        copyCount: state.copyCount + 1,
      };
    case COPY_COLLECTIONS_FAIL:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_FAIL,
        },
      };
    case SHOW_COLLECTIONS_SHARE:
      return {
        ...state,
        isShowShareMenu: true,
      };
    case CLEAN_COLLECTIONS_SHARE:
      return {
        ...state,
        isShowShareMenu: false,
      };
    default:
      return state;
  }
};
